const _excluded = ["indeterminate", "className", "id"];function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;} /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-multi-comp */
import React, { useEffect, useRef } from 'react';

import { ChevronUpDownIcon, ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/20/solid';
import { t } from "../../../I18N";











const IndeterminateCheckbox = (_ref) =>




{let { indeterminate, className = '', id } = _ref,rest = _objectWithoutProperties(_ref, _excluded);
  const ref = useRef(null);

  useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate, rest.checked]);

  return /*#__PURE__*/ (
    // eslint-disable-next-line react/jsx-props-no-spreading

    _jsx("label", {}, void 0, /*#__PURE__*/
    _jsx("span", { className: "sr-only" }, void 0,
    id === 'checkbox-header' ?
    t('System', 'Select all', null, false) :
    t('System', 'Select', null, false)
    ), /*#__PURE__*/
    React.createElement("input", _extends({
      type: "checkbox",
      ref: ref,
      className: `rounded cursor-pointer ${className}` },
    rest)
    )
    ));

};

const getIcon = (sorting) => {
  switch (sorting) {
    case false:
      return /*#__PURE__*/_jsx(ChevronUpDownIcon, { className: "w-4" });
    case 'asc':
      return /*#__PURE__*/_jsx(ChevronUpIcon, { className: "w-4" });
    case 'desc':
    default:
      return /*#__PURE__*/_jsx(ChevronDownIcon, { className: "w-4" });
  }
};

// eslint-disable-next-line comma-spacing
const CheckBoxHeader = ({ table }) => /*#__PURE__*/
React.createElement(IndeterminateCheckbox, {

  checked: table.getIsAllRowsSelected(),
  indeterminate: table.getIsSomeRowsSelected(),
  onChange: table.getToggleAllRowsSelectedHandler(),
  id: 'checkbox-header' }

);


// eslint-disable-next-line comma-spacing
const CheckBoxCell = ({ row }) => /*#__PURE__*/
React.createElement(IndeterminateCheckbox, {

  checked: row.getIsSelected(),
  disabled: !row.getCanSelect(),
  indeterminate: row.getIsSomeSelected(),
  onChange: row.getToggleSelectedHandler(),
  id: row.id }

);



export { CheckBoxHeader, CheckBoxCell, getIcon };